module.exports = __webpack_public_path__ + "img/home_icon_guanyuboya.3ecc33ba.svg";